<figure #chart style="width: 100%; margin: 0" class="chart-container"></figure>
